import { render, staticRenderFns } from "./FIFSurvey.vue?vue&type=template&id=6fdbad75&scoped=true&"
import script from "./FIFSurvey.vue?vue&type=script&lang=js&"
export * from "./FIFSurvey.vue?vue&type=script&lang=js&"
import style0 from "./FIFSurvey.vue?vue&type=style&index=0&id=6fdbad75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdbad75",
  null
  
)

export default component.exports